export default __webpack_public_path__ + "static/media/Left-Image.305b89c8.jpg";